import { useState } from "react";
import ReactPaginate from "react-paginate";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { BiEditAlt, BiTrash } from "react-icons/bi";
import { ThreeDots } from "react-loader-spinner";
import LogoutComponent from "../../Pages/Logout";
import SuccessToast from "../Toast/SuccessToast";
import ErrorToast from "../Toast/ErrorToast";
import DivisionView from "../Modal/DivisionView";
import RegionEditModal from "../Modal/RegionEditModal";
import useRegionList from "./useRegionList";
import "./Commoncss.css";

/**
 * columns: [{ header, key }]                       -> plain text cell
 *          [{ header, viewKey, viewTitle }]        -> "View" button opening DivisionView
 */
const RegionListPage = ({
  field,          // "area" | "subDivision" | "division" | "circle" | "wing"
  label,          // "Area", "Sub-Division", ...
  CreateIcon,
  createLabel,
  columns,
  viewTab,
  renderCreate,   // (commonProps) => <CreateModal .../>
}) => {
  const list = useRegionList(field);
  const [viewing, setViewing] = useState(null); // { data, modalname }

  const toastHandlers = { onSuccess: list.setSuccessMsg, onError: list.setErrorMsg };

  return (
    <div className="region-list-page">
      <LogoutComponent tokenExpirationMsg={list.tokenMsg} />

      {list.successMsg !== "" && (
        <SuccessToast message={list.successMsg} show onClose={() => list.setSuccessMsg("")} />
      )}
      {list.errorMsg !== "" && (
        <ErrorToast message={list.errorMsg} show onClose={() => list.setErrorMsg("")} />
      )}

      <div className="region-list-actions d-flex justify-content-end">
        <button
          type="button"
          onClick={list.openCreate}
          className="btn text-white mt-2 mb-2 btn-success fsi-14 w-auto text-nowrap region-create-btn"
        >
          <CreateIcon size={18} />
          &nbsp;{createLabel}
        </button>
      </div>

      {list.createOpen &&
        renderCreate({ status: list.createOpen, btnClick: list.closeCreate, ...toastHandlers })}

      {list.editing && (
        <RegionEditModal
          status
          btnClick={list.closeEdit}
          toEditid={list.editing.id}
          modalname={`Edit ${label}`}
          fieldName={label}
          field={field}
          fieldValue={list.editing.value}
          editData={list.editing.item || list.editing}
          {...toastHandlers}
        />
      )}

      {viewing && (
        <DivisionView
          status
          btnClick={() => setViewing(null)}
          modalname={viewing.modalname}
          tab={viewTab}
          data={viewing.data}
        />
      )}

      <div className="table-responsive">
        <table className="table">
          <thead className="table-header-background-color">
            <tr className="fsi-14">
              {columns.map((c) => (
                <th key={c.header} className="text-nowrap">{c.header}</th>
              ))}
              <th className="text-nowrap">Action</th>
            </tr>
          </thead>
          <tbody>
            {!list.isLoading && list.data.length === 0 ? (
              <tr>
                <td
                  colSpan={columns.length + 1}
                  className="text-center py-4 text-muted fw-bold"
                >
                  No data found
                </td>
              </tr>
            ) : (
              list.currentItems.map((item) => (
              <tr key={item.id} className="fsi-14">
                {columns.map((c) => (
                  <td key={c.header} className="p-2 align-middle text-nowrap">
                    {c.viewKey ? (
                      <button
                        type="button"
                        className="view-circle"
                        onClick={() =>
                          setViewing({ data: item[c.viewKey], modalname: c.viewTitle })
                        }
                      >
                        View
                      </button>
                    ) : (
                      c.key === "locationDescription"
                        ? (item.locationDescription || item.location_description || "-")
                        : item[c.key]
                    )}
                  </td>
                ))}
                <td className="p-2 align-middle">
                  <div className="d-flex justify-content-start">
                    <button
                      className="btn"
                      onClick={() => list.setEditing({ id: item.id, value: item[field], item })}
                    >
                      <BiEditAlt color="green" size={15} />
                    </button>
                    <button className="btn" onClick={() => list.onDelete(item.id)}>
                      <BiTrash color="red" size={15} />
                    </button>
                  </div>
                </td>
              </tr>
            ))
            )}
          </tbody>
        </table>

        {list.isLoading && (
          <div className="d-flex justify-content-center w-100 mt-5">
            <ThreeDots visible height="20" width="40" color="#3369a6" radius="7" ariaLabel="three-dots-loading" />
          </div>
        )}
      </div>

      {list.data.length !== 0 && (
        <div className="region-list-pagination d-flex justify-content-between mt-2 align-items-center">
          <ReactPaginate
            breakLabel="..."
            nextLabel={<GrFormNext />}
            previousLabel={<GrFormPrevious />}
            onPageChange={(e) => list.setCurrentPage(e.selected)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={list.pageCount}
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            activeClassName="active"
          />
        </div>
      )}
    </div>
  );
};

export default RegionListPage;